<div class="content-wrapper pb-5 solicitudes-usuarios-container">
  <div class="page-title-box d-flex flex-wrap align-items-center justify-content-between mb-4">
    <div>
      <h3 class="page-title m-0 d-flex align-items-center">
        <div class="title-icon-badge mr-3">
          <i class="fas fa-users-cog"></i>
        </div>
        <span>Estadísticas de Solicitudes y Usuarios</span>
      </h3>
      <p class="text-muted small mb-0 mt-1">Solicitudes por estado, actividad de usuarios y cobertura del padrón</p>
    </div>
    <a class="btn btn-outline-brand rounded-pill px-4 mt-2 mt-sm-0 d-inline-flex align-items-center font-weight-bold" [routerLink]="['/estadisticas-sistema']">
      <i class="fas fa-arrow-left mr-2"></i> Volver a Estadísticas
    </a>
  </div>

  <!-- Filtros de fecha -->
  <div class="card filter-card mb-4 border-0 shadow-sm">
    <div class="card-header d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <i class="fas fa-calendar-alt text-brand mr-2"></i>
        <h6 class="font-weight-bold m-0 text-uppercase tracking-wide text-dark" style="font-size: 0.85rem;">Período de análisis</h6>
      </div>
      <span class="small text-muted" *ngIf="desdeDatosTexto">
        <i class="fas fa-info-circle mr-1"></i>Datos disponibles desde <b>{{ desdeDatosTexto }}</b>
      </span>
    </div>
    <div class="card-body p-4">
      <div class="row align-items-end">
        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Desde</label>
          <input type="date" class="form-control" [(ngModel)]="filtros.fechaDesde" (change)="aplicarManual()" />
        </div>
        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Hasta</label>
          <input type="date" class="form-control" [(ngModel)]="filtros.fechaHasta" (change)="aplicarManual()" />
        </div>
        <div class="col-12 col-lg-6 mb-3">
          <label class="filter-label d-block">Accesos rápidos</label>
          <div class="btn-group btn-group-sm flex-wrap" role="group">
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === 'hoy'" [class.btn-outline-brand]="presetActivo !== 'hoy'" (click)="aplicarPreset('hoy')">Hoy</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === '7dias'" [class.btn-outline-brand]="presetActivo !== '7dias'" (click)="aplicarPreset('7dias')">7 días</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === '30dias'" [class.btn-outline-brand]="presetActivo !== '30dias'" (click)="aplicarPreset('30dias')">30 días</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === 'mes'" [class.btn-outline-brand]="presetActivo !== 'mes'" (click)="aplicarPreset('mes')">Este mes</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === 'ultimoMes'" [class.btn-outline-brand]="presetActivo !== 'ultimoMes'" (click)="aplicarPreset('ultimoMes')">Último mes completo</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === 'todos'" [class.btn-outline-brand]="presetActivo !== 'todos'" (click)="aplicarPreset('todos')">Todos los datos</button>
            <button type="button" class="btn btn-outline-brand" (click)="limpiar()"><i class="fas fa-undo-alt mr-1"></i> Limpiar</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="d-flex flex-column justify-content-center align-items-center py-5 my-5">
    <mat-progress-bar mode="determinate" [value]="progreso" color="primary" style="width: 320px; max-width: 80%;"></mat-progress-bar>
    <p class="text-muted font-weight-bold mt-3">Cargando estadísticas... {{ progreso }}%</p>
  </div>

  <!-- Error -->
  <div *ngIf="!isLoading && errorMsg" class="alert alert-danger text-center py-4">
    <i class="fas fa-exclamation-triangle mr-2"></i>{{ errorMsg }}
    <div class="mt-3">
      <button class="btn btn-brand-primary" (click)="cargar()"><i class="fas fa-redo mr-1"></i> Reintentar</button>
    </div>
  </div>

  <ng-container *ngIf="!isLoading && !errorMsg && resumen">
    <!-- KPIs -->
    <div class="row mb-4">
      <div class="col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-primary">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Solicitudes <i class="fas fa-info-circle kpi-info-icon" matTooltip="Total de solicitudes en los estados activos (en revisión, en auditoría médica, aprobada, anulada o en espera) dentro del período. Excluye las descartadas y las de inscripción." matTooltipPosition="above"></i></span>
              <div class="kpi-value">{{ resumen.totalSolicitudes | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-file-alt mr-1"></i> En los estados activos</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-clipboard-list"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-warning">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Inscripciones <i class="fas fa-info-circle kpi-info-icon" matTooltip="Solicitudes de inscripción (generadas desde inscripción-os) en estado parcial, completa (DDJJ), aprobada o anulada dentro del período." matTooltipPosition="above"></i></span>
              <div class="kpi-value">{{ resumen.totalInscripciones | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-file-signature mr-1"></i> {{ inscripcionesValidas() | formatNumber }} válidas <span class="text-danger font-weight-bold"><i class="fas fa-ban ml-2 mr-1"></i>{{ resumen.inscripcionesAnuladas | formatNumber }} anuladas</span></span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-file-signature"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-info">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Recibidas en el período <i class="fas fa-info-circle kpi-info-icon" matTooltip="Suma de 'Solicitudes' + 'Inscripciones' (solicitudes activas + inscripciones en parcial, DDJJ, aprobada o anulada). Debajo se muestra el promedio diario." matTooltipPosition="above"></i></span>
              <div class="kpi-value">{{ resumen.recibidas.total | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-calendar-day mr-1"></i> {{ resumen.recibidas.promedioDiario }} / día</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-inbox"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-success">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Tiempo hasta aprobación <i class="fas fa-info-circle kpi-info-icon" matTooltip="Promedio de días desde la creación de la solicitud hasta su aprobación." matTooltipPosition="above"></i></span>
              <div class="kpi-value">{{ formatoDias(resumen.tiempos.aprobacion.promedio) }}</div>
              <span class="kpi-subtext"><i class="fas fa-clock mr-1"></i> Promedio ({{ resumen.tiempos.aprobacion.n }} aprobadas)</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-stopwatch"></i></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Separador: totales que no varían con el período -->
    <div class="d-flex align-items-center mb-3">
      <div class="flex-grow-1" style="border-top: 1px solid #e2e8f0;"></div>
      <span class="mx-3 small text-muted text-uppercase font-weight-bold">
        <i class="fas fa-database mr-1"></i> Totales · no varían con el período
      </span>
      <div class="flex-grow-1" style="border-top: 1px solid #e2e8f0;"></div>
    </div>

    <!-- Usuarios / Familiares / Personas / Administradores -->
    <div class="row mb-4">
      <div class="col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Titulares <i class="fas fa-info-circle kpi-info-icon" matTooltip="Titulares activos (perfil AFILIADO, no suspendidos). Solo titulares, sin familiares a cargo." matTooltipPosition="above"></i></span>
              <div class="kpi-value">{{ resumen.totalUsuarios | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-user-check mr-1"></i> Titulares activos</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-id-card"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Familiares a cargo <i class="fas fa-info-circle kpi-info-icon" matTooltip="Familiares registrados a cargo de los titulares (adicionales, no titulares)." matTooltipPosition="above"></i></span>
              <div class="kpi-value">{{ resumen.totalFamiliares | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-users mr-1"></i> Adicionales (no titulares)</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-user-friends"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Personas cubiertas <i class="fas fa-info-circle kpi-info-icon" matTooltip="Total de personas cubiertas: titulares activos más familiares a cargo." matTooltipPosition="above"></i></span>
              <div class="kpi-value">{{ resumen.totalPersonasCubiertas | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-shield-alt mr-1"></i> Titulares + familiares a cargo</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-umbrella"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <div class="stat-kpi-card card border-0 shadow-sm h-100">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Administradores del sistema <i class="fas fa-info-circle kpi-info-icon" matTooltip="Usuarios activos con perfil distinto de AFILIADO: operadores y administradores del sistema. Es la nómina que lista 'Actividad por usuario'." matTooltipPosition="above"></i></span>
              <div class="kpi-value">{{ resumen.totalAdministradores | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-user-shield mr-1"></i> Activos <span class="text-muted">· Inactivos: {{ resumen.administradoresInactivos | formatNumber }}</span></span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-user-shield"></i></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tiempos -->
    <div class="card section-card border-0 shadow-sm mb-4">
      <div class="card-header bg-transparent d-flex align-items-center justify-content-between" style="cursor: pointer;" (click)="toggleSeccion('tiempos')">
        <div class="d-flex align-items-center">
          <i class="fas fa-hourglass-half text-brand mr-2"></i>
          <h6 class="font-weight-bold m-0">Tiempos de resolución (días) <i class="fas fa-info-circle kpi-info-icon" matTooltip="Promedio: media aritmética de los días de resolución. Mediana: valor central (el 50% se resolvió en menos y el 50% en más). P90: percentil 90; tiempo bajo el cual se resolvió el 90% de las solicitudes." matTooltipPosition="above"></i></h6>
        </div>
        <i class="fas" [class.fa-chevron-down]="secciones['tiempos']" [class.fa-chevron-right]="!secciones['tiempos']"></i>
      </div>
      <div class="card-body p-4" *ngIf="secciones['tiempos']">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3 mb-sm-0">
            <div class="p-3 rounded" style="background: #f0fdf4;">
              <div class="text-muted small text-uppercase font-weight-bold">Aprobación</div>
              <div class="d-flex justify-content-between mt-2">
                <div><span class="text-muted small">Promedio</span><div class="font-weight-bold h5 mb-0">{{ formatoDias(resumen.tiempos.aprobacion.promedio) }}</div></div>
                <div><span class="text-muted small">Mediana</span><div class="font-weight-bold h5 mb-0">{{ formatoDias(resumen.tiempos.aprobacion.mediana) }}</div></div>
                <div><span class="text-muted small">P90</span><div class="font-weight-bold h5 mb-0">{{ formatoDias(resumen.tiempos.aprobacion.p90) }}</div></div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="p-3 rounded" style="background: #fef2f2;">
              <div class="text-muted small text-uppercase font-weight-bold">Anulación</div>
              <div class="d-flex justify-content-between mt-2">
                <div><span class="text-muted small">Promedio</span><div class="font-weight-bold h5 mb-0">{{ formatoDias(resumen.tiempos.anulacion.promedio) }}</div></div>
                <div><span class="text-muted small">Mediana</span><div class="font-weight-bold h5 mb-0">{{ formatoDias(resumen.tiempos.anulacion.mediana) }}</div></div>
                <div><span class="text-muted small">P90</span><div class="font-weight-bold h5 mb-0">{{ formatoDias(resumen.tiempos.anulacion.p90) }}</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dona por estado + serie de recibidas -->
    <div class="row mb-4">
      <div class="col-12 col-lg-5 mb-4 mb-lg-0">
        <div class="card section-card border-0 shadow-sm h-100">
          <div class="card-header bg-transparent d-flex align-items-center justify-content-between" style="cursor: pointer;" (click)="toggleSeccion('estado')">
            <div class="d-flex align-items-center">
              <i class="fas fa-chart-pie text-brand mr-2"></i>
              <h6 class="font-weight-bold m-0">Solicitudes por estado</h6>
            </div>
            <i class="fas" [class.fa-chevron-down]="secciones['estado']" [class.fa-chevron-right]="!secciones['estado']"></i>
          </div>
          <ng-container *ngIf="secciones['estado']">
            <div class="card-body d-flex align-items-center justify-content-center">
              <div class="chart-wrap" style="max-width: 360px; width: 100%;">
                <canvas
                  baseChart
                  [data]="doughnutData"
                  [labels]="doughnutLabels"
                  [colors]="doughnutColors"
                  [chartType]="doughnutType"
                ></canvas>
              </div>
            </div>
            <ul class="list-unstyled px-4 pb-3 mb-0">
              <li class="d-flex justify-content-between py-1 border-bottom" *ngFor="let e of resumen.porEstado">
                <span>{{ e.nombre }}</span>
                <span class="font-weight-bold">{{ e.cantidad | formatNumber }}</span>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-lg-7">
        <div class="card section-card border-0 shadow-sm h-100">
          <div class="card-header bg-transparent d-flex align-items-center justify-content-between" style="cursor: pointer;" (click)="toggleSeccion('recibidas')">
            <div class="d-flex align-items-center">
              <i class="fas fa-chart-line text-brand mr-2"></i>
              <h6 class="font-weight-bold m-0">Recibidas por día</h6>
            </div>
            <i class="fas" [class.fa-chevron-down]="secciones['recibidas']" [class.fa-chevron-right]="!secciones['recibidas']"></i>
          </div>
          <div class="card-body d-flex flex-column" *ngIf="secciones['recibidas']">
            <div style="position: relative; flex-grow: 1; min-height: 320px;">
              <canvas
                baseChart
                [datasets]="lineData"
                [labels]="lineLabels"
                [options]="lineOptions"
                [colors]="lineColors"
                [legend]="lineLegend"
                [chartType]="lineType"
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Actividad por usuario -->
    <div class="card section-card border-0 shadow-sm">
      <div class="card-header bg-transparent d-flex align-items-center justify-content-between" style="cursor: pointer;" (click)="toggleSeccion('actividad')">
        <div class="d-flex align-items-center">
          <i class="fas fa-user-tag text-brand mr-2"></i>
          <h6 class="font-weight-bold m-0">Actividad por usuario <span class="badge badge-light border text-dark ml-2">{{ actividad.usuarios.length | formatNumber }} usuarios</span></h6>
        </div>
        <div class="d-flex align-items-center">
          <span class="text-muted small mr-2">{{ actividad.totalAtendidas | formatNumber }} transiciones registradas</span>
          <i class="fas" [class.fa-chevron-down]="secciones['actividad']" [class.fa-chevron-right]="!secciones['actividad']"></i>
        </div>
      </div>
      <div class="card-body p-0" *ngIf="secciones['actividad']">
        <div class="px-3 pt-3">
          <div class="search-box">
            <i class="fas fa-search search-icon"></i>
            <input type="text" class="form-control form-control-sm search-input" placeholder="Buscar usuario o rol..." [(ngModel)]="busquedaActividad" (input)="onBusquedaActividad()" />
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Rol</th>
                <th class="text-center">Atendidas</th>
                <th class="text-center">Aprobadas</th>
                <th class="text-center">Rechazadas</th>
                <th class="text-center">Auditoría</th>
                <th class="text-center">Espera</th>
                <th class="text-center">Recupero</th>
                <th class="text-center">% Trabajo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let u of actividadUsuariosPaginados">
                <td>{{ capitalizarNombre(u.userName) || '—' }}</td>
                <td><span class="badge badge-light border text-dark">{{ u.rol || '—' }}</span></td>
                <td class="text-center font-weight-bold">{{ u.atendidas | formatNumber }}</td>
                <td class="text-center">{{ u.aprobadas | formatNumber }}</td>
                <td class="text-center">{{ u.rechazadas | formatNumber }}</td>
                <td class="text-center">{{ u.auditoria | formatNumber }}</td>
                <td class="text-center">{{ u.espera | formatNumber }}</td>
                <td class="text-center">{{ u.recupero | formatNumber }}</td>
                <td class="text-center">{{ u.porcentaje }}%</td>
              </tr>
              <tr *ngIf="!actividad.usuarios || actividad.usuarios.length === 0">
                <td colspan="9" class="text-center text-muted py-4">Sin actividad registrada en el período.</td>
              </tr>
              <tr *ngIf="actividad.usuarios && actividad.usuarios.length > 0 && actividadUsuariosFiltrados.length === 0">
                <td colspan="9" class="text-center text-muted py-4">Sin resultados para la búsqueda.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center px-3 py-2 border-top" *ngIf="actividad.usuarios && actividad.usuarios.length > 0">
          <button class="btn btn-sm btn-outline-brand" [disabled]="pageActividad === 0" (click)="paginaActividadAnterior()">
            <i class="fas fa-chevron-left mr-1"></i> Anterior
          </button>
          <span class="small text-muted font-weight-bold">Página {{ pageActividad + 1 }} de {{ totalPaginasActividad }}</span>
          <button class="btn btn-sm btn-outline-brand" [disabled]="pageActividad + 1 >= totalPaginasActividad" (click)="paginaActividadSiguiente()">
            Siguiente <i class="fas fa-chevron-right ml-1"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Usuarios que más atienden -->
    <div class="card section-card border-0 shadow-sm mt-4">
      <div class="card-header bg-transparent d-flex align-items-center justify-content-between" style="cursor: pointer;" (click)="toggleSeccion('top20')">
        <div class="d-flex align-items-center">
          <i class="fas fa-chart-bar text-brand mr-2"></i>
          <h6 class="font-weight-bold m-0">Usuarios que más atienden (top 20)</h6>
        </div>
        <i class="fas" [class.fa-chevron-down]="secciones['top20']" [class.fa-chevron-right]="!secciones['top20']"></i>
      </div>
      <div class="card-body" *ngIf="secciones['top20']">
        <div style="position: relative; height: 360px;">
          <canvas
            baseChart
            [datasets]="atencionData"
            [labels]="atencionLabels"
            [options]="atencionOptions"
            [chartType]="atencionType"
          ></canvas>
        </div>
      </div>
    </div>

    <!-- Solicitudes por sede -->
    <div class="card section-card border-0 shadow-sm mt-4">
      <div class="card-header bg-transparent d-flex align-items-center justify-content-between" style="cursor: pointer;" (click)="toggleSeccion('sede')">
        <div class="d-flex align-items-center">
          <i class="fas fa-building text-brand mr-2"></i>
          <h6 class="font-weight-bold m-0">Solicitudes por sede</h6>
        </div>
        <div class="d-flex align-items-center">
          <span class="badge badge-light border text-dark mr-2">Total: {{ totalPorSede() | formatNumber }}</span>
          <i class="fas" [class.fa-chevron-down]="secciones['sede']" [class.fa-chevron-right]="!secciones['sede']"></i>
        </div>
      </div>
      <div class="card-body" *ngIf="secciones['sede']">
        <div style="position: relative; height: 400px;">
          <canvas
            baseChart
            [datasets]="porSedeData"
            [labels]="porSedeLabels"
            [options]="porSedeOptions"
            [chartType]="porSedeType"
          ></canvas>
        </div>
        <div class="mt-3 small">
          <span *ngIf="solicitudesSinSede() === 0" class="text-success">
            <i class="fas fa-check-circle mr-1"></i>La suma coincide con el total de Solicitudes ({{ resumen.totalSolicitudes | formatNumber }}).
          </span>
          <span *ngIf="solicitudesSinSede() > 0" class="text-warning">
            <i class="fas fa-exclamation-triangle mr-1"></i>{{ solicitudesSinSede() | formatNumber }} solicitudes sin sede (la suma de sedes difiere del total de Solicitudes).
          </span>
        </div>
      </div>
    </div>

    <!-- Solicitudes por plan aprobadas y anuladas -->
    <div class="card section-card border-0 shadow-sm mt-4">
      <div class="card-header bg-transparent d-flex align-items-center justify-content-between" style="cursor: pointer;" (click)="toggleSeccion('plan')">
        <div class="d-flex align-items-center">
          <i class="fas fa-layer-group text-brand mr-2"></i>
          <h6 class="font-weight-bold m-0">Solicitudes por plan aprobadas y anuladas</h6>
        </div>
        <i class="fas" [class.fa-chevron-down]="secciones['plan']" [class.fa-chevron-right]="!secciones['plan']"></i>
      </div>
      <div class="card-body" *ngIf="secciones['plan']">
        <div style="position: relative; height: 400px;">
          <canvas
            baseChart
            [datasets]="porPlanData"
            [labels]="porPlanLabels"
            [options]="porPlanOptions"
            [colors]="porPlanColors"
            [legend]="porPlanLegend"
            [chartType]="porPlanType"
          ></canvas>
        </div>
      </div>
    </div>

    <!-- Composición de solicitudes -->
    <ng-container *ngIf="mostrarDesglose">
    <div class="card section-card border-0 shadow-sm mt-4">
      <div class="card-header bg-transparent d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <i class="fas fa-layer-group text-brand mr-2"></i>
          <h6 class="font-weight-bold m-0">Composición de solicitudes <i class="fas fa-info-circle kpi-info-icon" matTooltip="Composición del total de solicitudes: 'Solicitudes' (regulares válidas: documentación presentada post-corte + estados activos), 'Presentadas' (estado 0, descartadas), 'Documentación presentada' (pre-corte, descartadas) e 'Inscripciones'." matTooltipPosition="above"></i></h6>
        </div>
        <span class="badge badge-light border text-dark">Total colección: {{ resumen.desgloseSolicitudes.total | formatNumber }}</span>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-lg-5">
            <div style="position: relative; height: 320px;">
              <canvas
                baseChart
                [data]="composicionData"
                [labels]="composicionLabels"
                [colors]="composicionColors"
                [chartType]="composicionType"
              ></canvas>
            </div>
          </div>
          <div class="col-12 col-lg-7 d-flex flex-column justify-content-center">
            <ul class="list-unstyled mb-0">
              <li class="d-flex justify-content-between py-1 border-bottom">
                <span><span class="mr-2" style="display:inline-block;width:12px;height:12px;border-radius:3px;background:#580f2e;"></span>Solicitudes</span>
                <span class="font-weight-bold">{{ resumen.desgloseSolicitudes.activas | formatNumber }}</span>
              </li>
              <li class="d-flex justify-content-between py-1 border-bottom">
                <span><span class="mr-2" style="display:inline-block;width:12px;height:12px;border-radius:3px;background:#9aa3af;"></span>Presentadas (estado 0)</span>
                <span class="font-weight-bold">{{ resumen.desgloseSolicitudes.estado0 | formatNumber }}</span>
              </li>
              <li class="d-flex justify-content-between py-1 border-bottom">
                <span><span class="mr-2" style="display:inline-block;width:12px;height:12px;border-radius:3px;background:#3b82f6;"></span>Documentación presentada (estado 1)</span>
                <span class="font-weight-bold">{{ resumen.desgloseSolicitudes.estado1 | formatNumber }}</span>
              </li>
              <li class="d-flex justify-content-between py-1 border-bottom">
                <span><span class="mr-2" style="display:inline-block;width:12px;height:12px;border-radius:3px;background:#f59e0b;"></span>Inscripciones</span>
                <span class="font-weight-bold">{{ resumen.desgloseSolicitudes.inscripciones | formatNumber }}</span>
              </li>
              <li class="d-flex justify-content-between py-1">
                <span><span class="mr-2" style="display:inline-block;width:12px;height:12px;border-radius:3px;background:#a78bfa;"></span>Inscripciones aprobadas (estado 4)</span>
                <span class="font-weight-bold">{{ resumen.desgloseSolicitudes.inscripcionesAprobadas | formatNumber }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Presentadas (estado 0) por mes -->
    <div class="card section-card border-0 shadow-sm mt-4">
      <div class="card-header bg-transparent d-flex align-items-center">
        <i class="fas fa-chart-line text-brand mr-2"></i>
        <h6 class="font-weight-bold m-0">Presentadas (estado 0) por mes</h6>
      </div>
      <div class="card-body">
        <div style="position: relative; height: 320px;">
          <canvas
            baseChart
            [datasets]="presentadasLineData"
            [labels]="presentadasLineLabels"
            [options]="presentadasLineOptions"
            [colors]="presentadasLineColors"
            [legend]="presentadasLineLegend"
            [chartType]="presentadasLineType"
          ></canvas>
        </div>
      </div>
    </div>
    </ng-container>
  </ng-container>
</div>
